import { DeliveryType } from "./deliveryTypes";

/**
 * This is main constants which should be used at aggregator to define order type. Order
 * type can be used for next logic blocks:
 * - Branches
 * - Ordering
 * - Addresses
 * Please note that for usage with code with should use another order types which have literal
 * values instead. Check "DeliveryTypes" constants to check more information
 */
export enum OrderType {
  Delivery = 1,
  Pickup = 2,
  DineIn = 3,
  /** Mean just delivery and pickup */
  Both = 4,
}

export const OrderTypeMap = {
  [DeliveryType.Delivery]: OrderType.Delivery,
  [DeliveryType.PickUp]: OrderType.Pickup,
  [DeliveryType.DineIn]: OrderType.DineIn,
  /** Mean just delivery and pickup */
  [DeliveryType.Both]: OrderType.Both,
};

export const OrderTypeTranslationKeys: {
  [key in OrderType.Delivery | OrderType.Pickup]: string;
} = {
  [OrderType.Delivery]: "txt_order_type_1",
  [OrderType.Pickup]: "txt_order_type_2",
};

export const DeliveryTypeMap = {
  [OrderType.Delivery]: DeliveryType.Delivery,
  [OrderType.Pickup]: DeliveryType.PickUp,
  [OrderType.Both]: DeliveryType.Both,
};
